
//#region src/storage.ts
var Store = class {
	set(key, value) {
		localStorage.setItem(key, JSON.stringify(value));
	}
	delete(key) {
		localStorage.removeItem(key);
	}
	get(key) {
		const v = localStorage.getItem(key);
		if (v) try {
			const ret = JSON.parse(v);
			return ret;
		} catch (err) {
			console.error("Store can not parse value", err);
			return null;
		}
		return null;
	}
};
var storage_default = Store;

//#endregion
exports.Storage = storage_default;